// @ts-ignore
/* eslint-disable */
import request from '@/utils/http/request';

/** 获取用户信息 获取用户信息 POST /tracingapi/auth/info */
export async function AuthControllerInfo(
  body: TracingApi.InfoQueryDto,
  options?: { [key: string]: any },
) {
  return request<TracingApi.AuthDto>({
    url: `/tracingapi/auth/info`,
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}
